// extracted by mini-css-extract-plugin
module.exports = {"base":"Wait_base__2MGJd","message":"Wait_message___gvHX","state":"Wait_state__1Gm87"};